module.exports = __webpack_public_path__ + "static/media/Requested.bc198caf.png";